var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19169 14.0392C2.85652 14.0392 0.149902 11.3262 0.149902 7.99742C0.149902 4.66866 2.85652 1.94922 6.19169 1.94922C6.87796 1.94922 7.545 2.04543 8.18638 2.24425C8.44293 2.32122 8.58403 2.5906 8.50707 2.84715C8.4301 3.1037 8.16072 3.2448 7.90417 3.16784C7.359 3.00108 6.78176 2.91129 6.19169 2.91129C3.38886 2.91129 1.11197 5.18818 1.11197 7.99101C1.11197 10.7938 3.38886 13.0707 6.19169 13.0707C8.99451 13.0707 11.2714 10.7938 11.2714 7.99101C11.2714 6.97763 10.9764 6.00273 10.4184 5.16894C10.2709 4.95087 10.3286 4.64942 10.5531 4.50191C10.7711 4.35439 11.0726 4.41211 11.2201 4.6366C11.8871 5.63073 12.2399 6.79163 12.2399 7.99742C12.2335 11.3262 9.52686 14.0392 6.19169 14.0392Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90102 3.5107C9.7499 3.5107 9.59877 3.44593 9.49083 3.32359L7.41106 0.93438C7.21676 0.711291 7.23835 0.365863 7.46144 0.171559C7.68453 -0.0227441 8.02995 -0.00115484 8.22426 0.221934L10.304 2.61115C10.4983 2.83424 10.4767 3.17966 10.2536 3.37397C10.1601 3.46752 10.0306 3.5107 9.90102 3.5107Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47603 5.2804C7.31051 5.2804 7.14499 5.20124 7.03705 5.05731C6.86433 4.81983 6.91471 4.4816 7.15219 4.30169L9.57738 2.53137C9.81487 2.35146 10.1531 2.40903 10.333 2.64651C10.5129 2.88399 10.4553 3.22223 10.2179 3.40214L7.79267 5.17965C7.69912 5.25162 7.59117 5.2804 7.47603 5.2804Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.62a73be87f999baec1f660ac001f74ee.svg";
export { ForwardRef as ReactComponent };